


















import Vue, { PropType } from 'vue';
import * as api from '@/api';

export default Vue.extend({
    props: {
        data: {
            type: Array as PropType<api.FilterBrand[]>,
            required: true,
        },
        selectedData: {
            type: Array as PropType<api.FilterBrand[]>,
            required: true,
        },
        showBack: {
            type: Boolean,
            default: true,
        },
        showSearch: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            search: '',
        };
    },
    computed: {
        displayData(): api.FilterBrand[] {
            if (this.search === '') {
                return this.data;
            }
            return this.data.filter((d) => d.name.toLowerCase().includes(this.search.toLowerCase()));
        },
    },
    methods: {
        handleClick(item: api.FilterBrand) {
            const idx = this.selectedData.findIndex((v) => v.id === item.id);
            if (idx === -1) {
                this.selectedData.push(item);
            } else {
                this.selectedData.splice(idx, 1);
            }
        },
    },
});
